import MultiPicker from '@/components/multi-picker'
import Utils from '@/common/js/utils'
import API from '@/api'
import dayjs from 'dayjs'
import ObjectValues from 'object.values'
import formCheckbox from './checkbox'

const SECONDS = 60
const PARENT_VALUE = '-1'

const datePicker = {
  props: {
    // 格式 yyyy-MM-dd
    value: String,
    startDate: String,
    endDate: String
  },
  render() {
    return this.$scopedSlots.default({
      clickHandler: this.handleClick
    })
  },
  methods: {
    handleClick() {
      const self = this
      this.$vux.datetime.show({
        value: this.value,
        startDate: this.startDate,
        endDate: this.endDate,
        confirmText: '确认',
        cancelText: '取消',
        onConfirm(value) {
          self.$emit('change', value)
        }
      })
    }
  }
}

// 日期选择器的常规版
// 用于一般的互动营销活动
const regularDatePicker = {
  mixins: [datePicker],
  props: {
    placeholder: String
  },
  render() {
    return (
      <div class="form-item date" onClick={this.handleClick}>
        {
          this.value ||
          <span>请选择{this.placeholder}</span>
        }
      </div>
    )
  }
}

export default {
  shouldScrollTop: true,
  components: {
    MultiPicker,
    datePicker,
    regularDatePicker,
    formCheckbox
  },
  data() {
    return {
      countDownText: '',
      limitCount: {},
      pending: false,
      initMultipleSign : null,
      updatingMultiple : false,
      isRenderDropDown:false
    }
  },
  watch: {
    formMap(val) {
      val && this.scrollTop()
    }
  },
  methods: {
    getInputFragment(formItemStyle) {
      this.formItemStyle = formItemStyle
      return this.formSetting.items.map(this.getInputFragmentCb)
    },
    getInputFragmentCb(item, index) {
      // 单行文本
      if (item.type === 'itemTypeText') {
        return (
          <input
            value={this.formMap[item.key]}
            data-key={item.key}
            class="form-item"
            style={this.formItemStyle}
            placeholder={item.placeholder}
            onInput={this.handleInput}
            onFocus={this.handleBlurForFixBUG}
            onBlur={this.handleBlurForFixBUG}
          />
        )
      }
      // 多行文本
      if (item.type === 'itemTypeMultiLineText') {
        return (
          <textarea
            value={this.formMap[item.key]}
            data-key={item.key}
            class="form-item"
            style={this.formItemStyle}
            placeholder={item.placeholder}
            onInput={this.handleInput}
            onFocus={this.handleBlurForFixBUG}
            onBlur={this.handleBlurForFixBUG}
          />
        )
      }
      // 手机
      if (item.type === 'itemTypePhone') {
        return (
          <input
            value={this.formMap[item.key]}
            data-key={item.key}
            class="form-item"
            type="tel"
            maxlength="11"
            style={this.formItemStyle}
            placeholder={item.placeholder}
            onInput={this.handleInput}
            onFocus={this.handleBlurForFixBUG}
            onBlur={this.handleBlurForFixBUG}
          />
        )
      }
      // 需要短信验证码
      if (item.type === 'itemTypeCode') {
        return (
          <x-input
            title={item.placeholder}
            class="form-item dj-code"
            show-clear={false}
            max={4}
            style={this.formItemStyle}
            onInput={this.handleSelect(item.key)}
            model={this.value} >
            <div slot="right" onClick={this.handleClickGetCodeBtn} class="dj-code-btn">
              {this.countDownText ? this.countDownText + 's' : item.submitButtonText}
            </div>
          </x-input>
        )
      }
      // 单选
      if (item.type === 'itemTypeSelect') {
        return (
          <select
            data-key={item.key}
            onInput={this.handleSingleSelect(item.key)}
            onFocus={this.handleBlurForFixBUG}
            onBlur={this.handleBlurForFixBUG}
            value={this.formMap[item.key]}
            class="form-item select"
            style={this.formItemStyle}
          >
            <option hidden selected disabled value="">{item.placeholder}</option>
            {
              item.range.map(d => (
                <option data-value={d} value={d}>{d}</option>
              ))
            }
          </select>
        )
      }
      if (item.type === 'itemTypeCheckbox') {
        return (
          <form-checkbox
            formMap={this.formMap}
            item={item}
            formItemStyle={this.formItemStyle}
            changeForm={this.setFormMap}
          />
        )
      }
      // 日期
      if (item.type === 'itemTypeDate') {
        const [startDate, endDate] = item.range

        return (
          <regular-date-picker
            data-key={item.key}
            value={this.formMap[item.key]}
            startDate={dayjs.unix(startDate).format('YYYY-MM-DD')}
            endDate={dayjs.unix(endDate).format('YYYY-MM-DD')}
            onChange={this.handleSelect(item.key)}
            style={this.formItemStyle}
            placeholder={item.placeholder}
          />
        )
      }
      // 级联选择
      if (item.type === 'itemTypeCascader') {
        const arr = this._setSelectData(item.range)

        return (
          <multi-picker
            value={this.formMap[item.key] }
            visible={this.visible}
            class="form-item dj-picker"
            show-name={true}
            title={item.placeholder}
            style={this.formItemStyle}
            limitCount={this.limitCount[item.key]}
            list={arr}
            data-key={item.key}
            onInput={this.handlePicker(item.key)}
          />
        )
      }
    },

    /**
     * 为解决 iOS微信 键盘关闭关闭导致页面空缺的问题
     * 参考： https://blog.csdn.net/wh_xmy/article/details/86472151
     */
    handleBlurForFixBUG() {
      if (!this.$options.shouldScrollTop) return null
      if(+this.$route.params.eventId === 246927) return null
      setTimeout(() => {
        const scrollHeight = (document.documentElement.scrollTop || document.body.scrollTop || 0)
        window.scrollTo(0, 170)
      }, 200)
    },
    scrollTop() {
      if (!this.$options.shouldScrollTop) return null

      // window.document.body.scrollTop = window.document.documentElement.scrollTop = 300
    },
    async checkLimitCount() {
      try {
        this.$vux.loading.show({ text: '加载中' })
        const token = this.$storage.getItem('token')
        const openid = this.$storage.getItem('openid')
        const resp = await this.$http({
          method: 'POST',
          url: API.common.checkLimitCountBak,
          params: {
            token,
            openid,
            id: this.$route.params.eventId
          }
        })
        this.limitCount = Object.assign({}, this.limitCount, resp)
      } catch (error) {
        console.error(error)
      } finally {
        this.$vux.loading.hide()
      }
    },
    handleClickGetCodeBtn(e,callback=null) {
      const {phone} = this.formMap
      if (!this._checkPhoneNumber(phone)) {
        this.$vux.toast.show({
          text: '请输入正确的手机号',
          type: 'text',
          width: '14em'
        })
        return false
      }
      this._sendSms(phone).then(res => {
        if(callback === null){
          if (!this.timer) {
            this.countDownText = SECONDS
            this.show = false
            this.timer = setInterval(() => {
              if (
                this.countDownText > 0 &&
                this.countDownText <= SECONDS
              ) {
                this.countDownText--
              } else {
                this.show = true
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
        }else{
          callback()
        }

      }).catch(error => {
        console.log(error)
        this.$vux.toast.show({
          text: process.env.NODE_ENV === 'production' ? '短信发送失败' : error.message,
          type: 'text',
          width: '14em'
        })
      })
    },
    _checkRequired() {
      let items = this.$store.state.activitiesManager ? this.$store.state.activitiesManager.form.items : this.$store.state.eventRuntime.form.items
      return ObjectValues(items).some(item => {
        if (item.required) {
          if (!this.formMap[item.key]) {
            this.$vux.toast.show({
              text: '请输入' + item.placeholder,
              type: 'text',
              width: '14em'
            })
            return true
          }
        }
      })
    },
    _checkPhoneNumber(phone) {
      return /^1\d{10}$/.test(phone)
    },
    formCheck() {
      const { code, phone } = this.formMap

      // 判断是否有验证码
      let items = this.$store.state.activitiesManager ? this.$store.state.activitiesManager.form.items : this.$store.state.eventRuntime.form.items

      if (items.some(d => d.type === 'itemTypePhone' && d.required)) {
        if (!this._checkPhoneNumber(phone)) {
          this.$vux.toast.show({
            text: '请输入正确的手机号',
            type: 'text',
            width: '14em'
          })
          this.pending = false
          return false
        }
      }

      if (items.some(d => d.type === 'itemTypePhone' && d.range === 1)) {
        if (!code) {
          this.$vux.toast.show({
            text: '请输入验证码',
            type: 'text',
            width: '14em'
          })
          this.pending = false
          return false
        }
      }

      // 判断必填项
      if (this._checkRequired()) {
        this.pending = false
        return false
      }

      return true
    },
    parseParams(str = '') {
      let ret = {}
      if (str.includes('?')) {
        str = str.replace('?', '')
      }
      if (str && str.includes('=')) {
        let arr = str.split('&')
        arr.map(d => {
          ret[d.split('=')[0]] = d.split('=')[1]
        })
      }
      return ret
    },
    handleClickSubmitCourse(api, params = {}) {
      return async e => {
        e.stopPropagation()
        if (this.pending) {
          return
        }

        this.pending = true

        const pass = this.formCheck()

        if (!pass) {
          return false
        }

        const token = this.$storage.getItem('token')
        const openid = this.$storage.getItem('openid')
        const channel = this.$storage.getItem('prev_channel') || this.$storage.getItem('channel')
        const search = window.location.search
        const configs = this.parseParams(search)
        const way = configs['way'] ? configs['way'] : 0
        const sid = this.$storage.getItem('sid') || '0'
        let resp
        try {
          this.$vux.loading.show({text: '加载中'})
          resp = await this.$http({
            method: 'POST',
            url: api,
            params: {
              token,
              openid,
              channel,
              activity_id: this.$route.params.eventId,
              ...this.formMap,
              ...params,
              way:way,
              sid,
              prev_uid: this.$storage.getItem('puid')
            }
          })

          this.doAfterSumbitSuccess(resp)
          return resp
        } catch (error) {
          this.$vux.toast.show({
            text: error.message,
            type: 'text',
            width: '14em'
          })
        } finally {
          this.pending = false
          this.$vux.loading.hide()
        }
      }
    },
    handleInput(e) {
      this.setFormMap({
        [e.currentTarget.dataset.key]: e.currentTarget.value
      })
    },
    handleSelect(e) {
      return d => {
        this.setFormMap({
          [e]: d
        })
      }
    },
    handleSingleSelect(e) {
      return d => {
        this.setFormMap({
          [e]: d.target.value
        })
      }
    },
    handlePicker(e) {
      return (d) => {
        this.setFormMap({
          [e]: d.toString().replace(/,/g, '-')
        })
      }
    },
    addCodeType(items) {
      // 验证码处理
      if (items.some(item => item.type === 'itemTypeCode')) return false

      let list = Utils.deepClone(items)
      items.forEach((item, index) => {
        if (item.type === 'itemTypePhone') {
          if (item.range === 1) {
            list.splice(index + 1, 0, {
              type: 'itemTypeCode',
              range: 4,
              placeholder: '验证码',
              submitButtonText: '获取验证码',
              key: 'code'
            })
          }
        }
      })
      return list
    },
    _sendSms(mobile) {
      const token = this.$storage.getItem('token')
      const openid = this.$storage.getItem('openid')
      return new Promise(async (resolve, reject) => {
        try {
          this.$vux.loading.show({text: '加载中'})
          let resp = await this.$http({
            method: 'POST',
            url: API.eleven.sendSms,
            params: {
              token,
              openid,
              mobile,
              activity_id: this.$route.params.eventId
            }
          })
          resolve(resp)
        } catch (error) {
          reject(error)
        } finally {
          this.$vux.loading.hide()
        }
      })
    },
    async _getAvatar() {
      this.$vux.loading.show({text: '加载中'})
      const token = this.$storage.getItem('token')
      const openid = this.$storage.getItem('openid')
      try {
        let resp = this.$http({
          method: 'POST',
          url: API.eleven.getAvatar,
          params: {
            token,
            openid
          }
        })
        return resp
      } catch (error) {
        console.error(error)
      } finally {
        // this.$vux.loading.hide()
      }
    },

    _setSelectData(data) {
      /**
       * 铺平数组
       * id, parent {string}
       */
      const flatten = (arr, parent = PARENT_VALUE) => arr.reduce((a, b) => {
        return [...a, ...(Array.isArray(b.children) ? [...flatten(b.children, b.id.toString()), {
          name: b.name,
          id: b.id.toString(),
          parent,
          limit: b.limit
        }] : [{
          name: b.name,
          id: b.id.toString(),
          parent,
          limit: b.limit
        }])]
      }, [])
      return flatten(data)
    }
  }
}